// Browser polyfills
import 'babel-polyfill';
import 'whatwg-fetch';
import './utils/string-template';

// Libs
import React from 'react';
import { Provider, connect } from 'react-redux';
import { Bridge } from '@nackle/bridge';
import Deck from './components/shared/deck';
import CompanySelect from './components/shared/company-select';
import { companyAdminURL, giftCodeAdminURL, dataAdminURL } from 'endpoints';
import LoadingOverlay from './components/shared/loader/loading-overlay.jsx';
import Error from './components/shared/error/error.jsx';
import { getStrings } from './app-dux/app-dux';
import { languageChangeEvent } from '@nackle/intl-tools';
import ActivityIndicator from './components/shared/activity-indicator';
// Redux
import appStore from './app-store';
import appAuth from './app-auth';

// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, getMiddleware as getRouteMiddleware } from './app-routing.jsx';

import './styles/style.scss';

/*******************************************************************************
 *  0. Shell Components
 */
class UserHeader extends React.Component {
    render() {
        return (
            <div className="user-header">
                <div className="container">
                    <div className="user-info">
                        <span>{ this.props.user }</span>
                        <a href="#sign-out" role="button" onClick={ appAuth.signOut }>
                            Sign Out
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

class AdminHeader extends React.Component {
    render() {
        return (
            <div className="admin-header">
                <div className="container">
                    <span className="header-logo">
                        <img src={ this.props.logo } />
                    </span>
                    <CompanySelect
                        value={ this.props.companyId }
                        onChange={ this.handleCompanyChange }
                        className="primary-background"
                    />
                    <div className="button-container">
                        <a href={ `${ companyAdminURL }/company` } className="btn-small company-add">Add New Company</a>
                    </div>
                    { this.props.companyId &&
                        <div className="link-container" >
                            <a className="program-link" onClick={ this.handleProgramsClick }>Programs</a>
                            <span className="divider">|</span>
                            <a className="gift-code-link" href={ `${ giftCodeAdminURL }/${ this.props.companyId }` }>Gift Code Search</a>
                            <span className="divider">|</span>
                            <a className="data-admin-link" href={ `${ dataAdminURL }/${ this.props.companyId }` }>Data Admin</a>
                            <span className="divider">|</span>
                            <a className="reports-link" onClick={ this.handleReportsClick }>Reports</a>
                        </div>
                    }
                </div>
            </div>
        );
    }
    handleReportsClick = () => {
        const { companyId } = this.props;
        routeHistory.push( `/${ companyId }/reports` );
    };
    handleProgramsClick = () => {
        const { companyId } = this.props;


        routeHistory.push( `/${ companyId }/programs/` );
    };

    handleCompanyChange = ( e ) => {
        const companyId = e.target.value;

        if ( !companyId ) {
            if ( location.pathname.indexOf( '/health' ) >= 0 ) {
                routeHistory.push( '/health' );
            } else {
                routeHistory.push( '/' );
                //TODO: clear delegate token
            }
        } else {

            if ( location.pathname.indexOf( '/health' ) >= 0 ) {
                routeHistory.push( `/${ companyId }/health` );
            } else if ( location.pathname.indexOf( '/reports' ) >= 0 ) {
                routeHistory.push( `/${ companyId }/reports` );
            } else {
                routeHistory.push( `/${ companyId }/programs` );
            }
        }
    };
}

/*******************************************************************************
 *  1. App (root level component)
 */
class App extends React.Component {
    state = {
        loaded: false,
        user: '',
        locale: 'en-US',
        permissions: [],
        rosterPermissions: [],
        languageLoaded: false,
        contentLoading: false
    };

    componentDidMount() {
        languageChangeEvent.on( () => {
            this.setState( { languageLoaded: true } );
        } );
    }

    render() {
        const { user, permissions, rosterPermissions, languageLoaded, locale, contentLoading } = this.state;
        return (
            <Error>
                <Route render={ ( route ) => {

                    return (
                        <Bridge
                            auth={ appAuth }
                            onSignIn={ this.handleSignIn }
                            onAuthStateChange={ this.handlePermissionChange }
                            onSessionExpired={ e => {
                                e.preventDefault();
                                alert( 'Your session has expired.' );
                                appAuth.signOut();
                            } }
                        >
                            <div className="app-container stage">
                                {
                                    route.match ?
                                        <div key={ route.state.params.companyId }>
                                            <LoadingOverlay loading={ this.props.loading } />
                                            <Deck>
                                                <UserHeader user={ user } />
                                                <AdminHeader companyId={ route.state.params.companyId } logo={ this.props.logo } />
                                            </Deck>
                                            {

                                                permissions && permissions.length ?
                                                    ( languageLoaded || route.pathname === '/' || route.pathname === '/health' ) ?
                                                        <div className="container">
                                                            { React.cloneElement( route.component, { user, permissions, rosterPermissions, locale } ) }
                                                        </div>
                                                        :
                                                        <ActivityIndicator visible={ contentLoading } />
                                                    :
                                                    <h1>Access Denied</h1>
                                            }

                                        </div>
                                        :
                                        route.pathname && <Error error="path" />
                                }
                            </div>
                        </Bridge>
                    );
                } } />
            </Error>
        );
    }

    handleSignIn = async ( authState ) => {
        await routeHistory.refresh();
        this.setState( {
            user: authState.claims.name,
            locale: authState.claims.locale
        } );
    };
    handlePermissionChange = async ( authState ) => {
        this.setState( {
            languageLoaded: false,
            permissions: authState.claims.permissions[ 'service-awards-api' ] || [],
            rosterPermissions: authState.claims.permissions[ 'roster-studio-exp-api' ] || []
        } );

        if ( authState.delegate.claims.company_id ) {
            this.setState( {
                languageLoaded: true
            } );
            // await this.props.getStrings( this.state.locale );
            // this.setState( {
            //     contentLoading: false
            // } );
        }
    };
}

/*******************************************************************************
 *  2. Connect App component to the Redux store
 */
App = connect(
    // mapStateToProps
    ( state ) => {
        return {
            loading: state.app.loading,
            logo: state.company.activeCompany.primaryLogo,
            companyId: state.company.activeCompanyId,
        };
    },
    // mapDispatchToProps
    {
        getStrings
    }
)( App );

/*******************************************************************************
 *  3. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware( appStore ) );

/*******************************************************************************
 * 4. Render the the app
 */
import { createRoot } from 'react-dom/client';
const container = document.getElementById( 'app-root' );
const root = createRoot( container ); // createRoot(container!) if you use TypeScript
root.render(  
    <Provider store={ appStore }>
        <App />
    </Provider> 
    );

// Conditionally enable hot module reloading
if ( module.hot ) {
    module.hot.accept();
}

